import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SettingIcon from '../../images/setting';
import '../../styles/circularMenu.scss';

export class CircularMenu extends Component {
  componentDidMount() {
    this.createPie(55, 55, 50, 8);
  }

    createPie = (cx, cy, r, slices) => {
      let fromAngle; let toAngle;
      let fromCoordX; let fromCoordY;
      let toCoordX; let toCoordY;
      let path; let
        d;
      for (let i = 0; i < slices; i++) {
        path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        fromAngle = i * 360 / slices;
        toAngle = (i + 1) * 360 / slices;
        // console.log(fromAngle + ' ' + toAngle);
        fromCoordX = cx + (r * Math.cos(fromAngle * Math.PI / 180));
        fromCoordY = cy + (r * Math.sin(fromAngle * Math.PI / 180));
        toCoordX = cx + (r * Math.cos(toAngle * Math.PI / 180));
        toCoordY = cy + (r * Math.sin(toAngle * Math.PI / 180));
        // console.log(fromCoord + ' ' + toCoord);
        d = `M${cx},${cy} L${fromCoordX},${fromCoordY} A${r},${r} 0 0,1 ${toCoordX},${toCoordY}z`;
        // console.log(d);
        path.setAttributeNS(null, 'd', d);
        document.getElementById('pie').appendChild(path);
      }
    }

    render() {
      const {
        items, styleObject, onShapeClick, getConnectorSettings, connectorSettings,
      } = this.props;
      return (
        <div className="circular-menu">
          <svg viewBox="0 0 110 110" id="pie" />
          <SettingIcon className="setting-icon" />
          {items.map(({
            shapeName, Shape, style, separate,
          }, index) => (
            <div
              key={`${shapeName} Control`}
              className="shape-wrapper"
              style={style}
              onClick={() => {
                if (!separate) {
                  onShapeClick(shapeName);
                }
              }}
            >
              <Shape
                styleObject={styleObject}
                id={`${shapeName}control${index}`}
                showClose={false}
                getConnectorSettings={getConnectorSettings}
                connectorSettings={connectorSettings}
              />
            </div>
          ))}
        </div>
      );
    }
}

CircularMenu.propTypes = {
  items: PropTypes.arrayOf(Object).isRequired,
  styleObject: PropTypes.instanceOf(Object),
  onShapeClick: PropTypes.func.isRequired,
  getConnectorSettings: PropTypes.func.isRequired,
  connectorSettings: PropTypes.instanceOf(Object).isRequired,

};

CircularMenu.defaultProps = {
  styleObject: {},
};
